// Auto-generated by scripts/split_ui.js from data/hajjTimeline.js — do not edit.
export const HAJJ_UI = {
  "pageTitle": {
    "id": "Manasik Haji: Hari demi Hari",
    "en": "Hajj Manasik: Day by Day",
    "ar": "مناسك الحج: يوماً بيوم",
    "fr": "Manasik du Hajj : Jour par Jour",
    "de": "Haji Manasik: Tag für Tag",
    "es": "Manasik del Hajj: Día a Día",
    "ru": "Манасик Хаджа: День за Днём",
    "zh": "朝觐功课：逐日指南",
    "ja": "ハッジのマナシク：日ごとのガイド",
    "ko": "하지 마나시크: 날마다",
    "hi": "हज मनासिक: दिन-ब-दिन"
  },
  "pageSub": {
    "id": "Rangkaian ibadah haji 8–13 Dzulhijjah secara lengkap: amalan, status hukum, doa, dan dalilnya.",
    "en": "The complete sequence of Hajj rituals from 8–13 Dzulhijjah: practices, legal rulings, supplications, and their evidence.",
    "ar": "السلسلة الكاملة لمناسك الحج من الثامن إلى الثالث عشر من ذي الحجة: الأعمال، والأحكام الشرعية، والأدعية، وأدلتها.",
    "fr": "La séquence complète des rites du Hajj du 8 au 13 Dzulhijjah : pratiques, statuts juridiques, invocations et leurs preuves.",
    "de": "Die vollständige Abfolge der Haji-Rituale vom 8.–13. Dzulhijjah: Praktiken, Rechtsstatus, Bittgebete und ihre Belege.",
    "es": "La secuencia completa de los rituales del Hajj del 8 al 13 de Dzulhijjah: prácticas, dictámenes legales, súplicas y sus evidencias.",
    "ru": "Полная последовательность обрядов Хаджа с 8 по 13 Зуль-хиджа: действия, правовые положения, молитвы и их доказательства.",
    "zh": "8至13日尔·黑哲月朝觐功课的完整流程：功课内容、法律裁定、祈祷词及其依据。",
    "ja": "ズルヒッジャ月8〜13日のハッジ礼拝の完全な手順：実践、法的判断、祈り、およびその根拠。",
    "ko": "8~13 줄히자의 하지 의례의 완전한 순서: 실천 사항, 법적 판결, 기도문 및 그 근거.",
    "hi": "8–13 ज़ुल-हिज्जा के हज मनासिक का पूर्ण क्रम: अमल, शरई हुक्म, दुआएं और उनके दलाइल।"
  },
  "dashLabel": {
    "id": "Haji Hari demi Hari",
    "en": "Hajj Day by Day",
    "ar": "الحج يوماً بيوم",
    "fr": "Hajj Jour par Jour",
    "de": "Haji Tag für Tag",
    "es": "Hajj Día a Día",
    "ru": "Хадж День за Днём",
    "zh": "朝觐逐日指南",
    "ja": "日ごとのハッジ",
    "ko": "날마다 하지",
    "hi": "हज दिन-ब-दिन"
  },
  "dashHint": {
    "id": "Timeline lengkap manasik haji 8–13 Dzulhijjah",
    "en": "Complete timeline of Hajj manasik from 8–13 Dzulhijjah",
    "ar": "الجدول الزمني الكامل لمناسك الحج من الثامن إلى الثالث عشر من ذي الحجة",
    "fr": "Calendrier complet des manasik du Hajj du 8 au 13 Dzulhijjah",
    "de": "Vollständiger Zeitplan der Haji-Manasik vom 8.–13. Dzulhijjah",
    "es": "Cronograma completo de los manasik del Hajj del 8 al 13 de Dzulhijjah",
    "ru": "Полный временной график манасик Хаджа с 8 по 13 Зуль-хиджа",
    "zh": "8至13日尔·黑哲月朝觐功课完整时间表",
    "ja": "ズルヒッジャ月8〜13日のハッジ・マナシクの完全なタイムライン",
    "ko": "8~13 줄히자 하지 마나시크의 완전한 일정표",
    "hi": "8–13 ज़ुल-हिज्जा के हज मनासिक की पूर्ण समय-रेखा"
  },
  "statusRukun": {
    "id": "Rukun",
    "en": "Rukun (Pillar)",
    "ar": "ركن (فرض لا يُجبر بدم)",
    "fr": "Rukun (Pilier essentiel)",
    "de": "Rukun (Pflichtpfeiler)",
    "es": "Rukun (Pilar esencial)",
    "ru": "Рукун (Столп, обязательный элемент)",
    "zh": "柱功（Rukun）",
    "ja": "ルクン（必須の柱）",
    "ko": "루쿤 (필수 기둥)",
    "hi": "रुकुन (अनिवार्य स्तंभ)"
  },
  "statusWajib": {
    "id": "Wajib",
    "en": "Wajib (Obligatory)",
    "ar": "واجب",
    "fr": "Wajib (Obligatoire)",
    "de": "Wajib (Verpflichtend)",
    "es": "Wajib (Obligatorio)",
    "ru": "Ваджиб (Обязательное действие)",
    "zh": "瓦吉布（Wajib，必须）",
    "ja": "ワージブ（義務的行為）",
    "ko": "와집 (의무 행위)",
    "hi": "वाजिब (अनिवार्य कार्य)"
  },
  "statusSunnah": {
    "id": "Sunnah",
    "en": "Sunnah (Recommended)",
    "ar": "سنة (مستحب)",
    "fr": "Sunnah (Recommandé)",
    "de": "Sunnah (Empfohlen)",
    "es": "Sunnah (Recomendado)",
    "ru": "Сунна (Желательное действие)",
    "zh": "逊奈（Sunnah，圣行，推荐）",
    "ja": "スンナ（推奨行為）",
    "ko": "순나 (권장 행위)",
    "hi": "सुन्नह (अनुशंसित कार्य)"
  },
  "whatToDo": {
    "id": "Amalan & Tata Cara",
    "en": "Practices & Procedures",
    "ar": "الأعمال والإجراءات",
    "fr": "Pratiques et procédures",
    "de": "Praktiken & Abläufe",
    "es": "Prácticas y procedimientos",
    "ru": "Обряды и порядок их совершения",
    "zh": "功课与步骤",
    "ja": "礼拝行為と手順",
    "ko": "실천 사항 및 절차",
    "hi": "अमल और तरीका-ए-कार"
  },
  "duaLabel": {
    "id": "Doa / Dzikir",
    "en": "Du'a / Dhikr",
    "ar": "الدعاء / الذكر",
    "fr": "Du'a / Dhikr",
    "de": "Du'a / Dhikr",
    "es": "Du'a / Dhikr",
    "ru": "Ду'а / Зикр",
    "zh": "祈祷文 / 迪克尔（Dhikr）",
    "ja": "ドゥアー / ズィクル",
    "ko": "두아 / 디크르",
    "hi": "दुआ / ज़िक्र"
  },
  "evidenceLabel": {
    "id": "Dalil",
    "en": "Evidence (Dalil)",
    "ar": "الدليل",
    "fr": "Preuve (Dalil)",
    "de": "Beleg (Dalil)",
    "es": "Evidencia (Dalil)",
    "ru": "Довод (Далиль)",
    "zh": "依据（Dalil）",
    "ja": "根拠（ダリール）",
    "ko": "근거 (달릴)",
    "hi": "दलील (प्रमाण)"
  },
  "viewMap": {
    "id": "Lihat di Peta",
    "en": "View on Map",
    "ar": "عرض على الخريطة",
    "fr": "Voir sur la carte",
    "de": "Auf der Karte anzeigen",
    "es": "Ver en el mapa",
    "ru": "Посмотреть на карте",
    "zh": "在地图上查看",
    "ja": "地図で見る",
    "ko": "지도에서 보기",
    "hi": "नक्शे पर देखें"
  },
  "narrateBtn": {
    "id": "Dengarkan Langkah",
    "en": "Listen to the Steps",
    "ar": "استمع إلى الخطوات",
    "fr": "Écouter les étapes",
    "de": "Schritte anhören",
    "es": "Escuchar los pasos",
    "ru": "Прослушать шаги",
    "zh": "收听步骤",
    "ja": "手順を聞く",
    "ko": "단계 듣기",
    "hi": "चरण सुनें"
  },
  "mapTitle": {
    "id": "Peta Perjalanan Manasik",
    "en": "Manasik Journey Map",
    "ar": "خريطة رحلة المناسك",
    "fr": "Carte du parcours des Manasik",
    "de": "Manasik-Reisekarte",
    "es": "Mapa del recorrido de los Manasik",
    "ru": "Карта маршрута Манасик",
    "zh": "朝觐功课旅程地图",
    "ja": "マナーシク巡礼旅程マップ",
    "ko": "마나시크 여정 지도",
    "hi": "मनासिक यात्रा का नक्शा"
  },
  "mapHint": {
    "id": "Lokasi utama haji: Makkah, Mina, Muzdalifah, Arafah, dan Jamarat.",
    "en": "Key Hajj locations: Makkah, Mina, Muzdalifah, Arafah, and Jamarat.",
    "ar": "المواقع الرئيسية للحج: مكة المكرمة، منى، مزدلفة، عرفات، والجمرات.",
    "fr": "Lieux clés du Hajj : La Mecque, Mina, Muzdalifah, Arafah et Jamarat.",
    "de": "Wichtige Hajj-Orte: Makkah, Mina, Muzdalifah, Arafah und Jamarat.",
    "es": "Lugares clave del Hajj: La Meca, Mina, Muzdalifah, Arafah y Jamarat.",
    "ru": "Ключевые места Хаджа: Макка, Мина, Муздалифа, Арафат и Джамарат.",
    "zh": "朝觐主要地点：麦加、米纳、穆兹代里法、阿拉法特和贾马拉特。",
    "ja": "ハッジの主要地：マッカ、ミナー、ムズダリファ、アラファート、ジャマラート。",
    "ko": "하지 주요 장소: 마카, 미나, 무즈달리파, 아라파트, 자마라트.",
    "hi": "हज के प्रमुख स्थान: मक्का, मिना, मुज़्दलिफ़ा, अरफ़ात और जमरात।"
  },
  "mapLegendTitle": {
    "id": "Jarak dari Masjidil Haram (garis lurus)",
    "en": "Distance from Masjidil Haram (straight line)",
    "ar": "المسافة من المسجد الحرام (خط مستقيم)",
    "fr": "Distance de la Masjidil Haram (ligne droite)",
    "de": "Entfernung von der Masjidil Haram (Luftlinie)",
    "es": "Distancia desde la Masjidil Haram (línea recta)",
    "ru": "Расстояние от Масджидуль-Харам (по прямой)",
    "zh": "距麦斯吉德·哈拉姆的距离（直线）",
    "ja": "マスジドゥル・ハラームからの距離（直線）",
    "ko": "마스지딜 하람으로부터의 거리 (직선)",
    "hi": "मस्जिदुल हराम से दूरी (सीधी रेखा)"
  },
  "directionsLabel": {
    "id": "Rute Google Maps",
    "en": "Google Maps Route",
    "ar": "مسار خرائط جوجل",
    "fr": "Itinéraire Google Maps",
    "de": "Google Maps-Route",
    "es": "Ruta de Google Maps",
    "ru": "Маршрут в Google Maps",
    "zh": "谷歌地图路线",
    "ja": "Googleマップのルート",
    "ko": "구글 지도 경로",
    "hi": "गूगल मैप्स मार्ग"
  },
  "kmLabel": {
    "id": "km",
    "en": "km",
    "ar": "كم",
    "fr": "km",
    "de": "km",
    "es": "km",
    "ru": "км",
    "zh": "公里",
    "ja": "km",
    "ko": "km",
    "hi": "किमी"
  },
  "loc.makkah": {
    "id": "Masjidil Haram (Makkah)",
    "en": "Masjidil Haram (Makkah)",
    "ar": "المسجد الحرام (مكة المكرمة)",
    "fr": "Masjidil Haram (La Mecque)",
    "de": "Masjidil Haram (Mekka)",
    "es": "Masjidil Haram (La Meca)",
    "ru": "Масджидул-Харам (Мекка)",
    "zh": "禁寺（麦加）",
    "ja": "マスジドゥル・ハラーム（マッカ）",
    "ko": "마스지딜 하람 (마카)",
    "hi": "मस्जिदुल हराम (मक्का)"
  },
  "loc.mina": {
    "id": "Mina",
    "en": "Mina",
    "ar": "منى",
    "fr": "Mina",
    "de": "Mina",
    "es": "Mina",
    "ru": "Мина",
    "zh": "米纳",
    "ja": "ミナー",
    "ko": "미나",
    "hi": "मिना"
  },
  "loc.muzdalifah": {
    "id": "Muzdalifah",
    "en": "Muzdalifah",
    "ar": "مزدلفة",
    "fr": "Muzdalifah",
    "de": "Muzdalifah",
    "es": "Muzdalifah",
    "ru": "Муздалифа",
    "zh": "穆兹达利法",
    "ja": "ムズダリファ",
    "ko": "무즈달리파",
    "hi": "मुज़्दलिफ़ा"
  },
  "loc.arafah": {
    "id": "Arafah (Jabal Rahmah)",
    "en": "Arafah (Jabal Rahmah)",
    "ar": "عرفة (جبل الرحمة)",
    "fr": "Arafah (Jabal Rahmah)",
    "de": "Arafah (Jabal Rahmah)",
    "es": "Arafah (Jabal Rahmah)",
    "ru": "Арафа (Джабаль Рахма)",
    "zh": "阿拉法特（仁慈山）",
    "ja": "アラファー（ジャバル・ラフマ）",
    "ko": "아라파 (자발 라흐마)",
    "hi": "अरफ़ाह (जबल रहमा)"
  },
  "loc.jamarat": {
    "id": "Jamarat (Mina)",
    "en": "Jamarat (Mina)",
    "ar": "الجمرات (منى)",
    "fr": "Jamarat (Mina)",
    "de": "Jamarat (Mina)",
    "es": "Jamarat (Mina)",
    "ru": "Джамарат (Мина)",
    "zh": "贾马拉特（米纳）",
    "ja": "ジャマラート（ミナー）",
    "ko": "자마라트 (미나)",
    "hi": "जमरात (मिना)"
  },
  "day8": {
    "id": "8 Dzulhijjah",
    "en": "8 Dhul Hijjah",
    "ar": "٨ ذو الحجة",
    "fr": "8 Dhou Al-Hijja",
    "de": "8. Dhul Hiddscha",
    "es": "8 Dhul Hiyya",
    "ru": "8 Зуль-Хиджа",
    "zh": "斋月十二月8日（朱勒·海贾月8日）",
    "ja": "ズルヒッジャ月8日",
    "ko": "줄히자 8일",
    "hi": "8 ज़ुल-हिज्जा"
  },
  "day9": {
    "id": "9 Dzulhijjah",
    "en": "9 Dhul Hijjah",
    "ar": "٩ ذو الحجة",
    "fr": "9 Dhou Al-Hijja",
    "de": "9. Dhul Hiddscha",
    "es": "9 Dhul Hiyya",
    "ru": "9 Зуль-Хиджа",
    "zh": "朱勒·海贾月9日",
    "ja": "ズルヒッジャ月9日",
    "ko": "줄히자 9일",
    "hi": "9 ज़ुल-हिज्जा"
  },
  "day10": {
    "id": "10 Dzulhijjah — Nahr",
    "en": "10 Dhul Hijjah — Nahr",
    "ar": "١٠ ذو الحجة — النحر",
    "fr": "10 Dhou Al-Hijja — Nahr",
    "de": "10. Dhul Hiddscha — Nahr",
    "es": "10 Dhul Hiyya — Nahr",
    "ru": "10 Зуль-Хиджа — Нахр",
    "zh": "朱勒·海贾月10日——宰牲日（Nahr）",
    "ja": "ズルヒッジャ月10日 — ナフル（Nahr）",
    "ko": "줄히자 10일 — 나흐르(Nahr)",
    "hi": "10 ज़ुल-हिज्जा — नहर (Nahr)"
  },
  "daytasyrik": {
    "id": "11–13 Dzulhijjah — Tasyrik",
    "en": "11–13 Dhul Hijjah — Tasyrik",
    "ar": "١١–١٣ ذو الحجة — أيام التشريق",
    "fr": "11–13 Dhou Al-Hijja — Tasyrik",
    "de": "11.–13. Dhul Hiddscha — Tasyrik",
    "es": "11–13 Dhul Hiyya — Tasyrik",
    "ru": "11–13 Зуль-Хиджа — Ташрик",
    "zh": "朱勒·海贾月11–13日——塔什里克日（Tasyrik）",
    "ja": "ズルヒッジャ月11～13日 — タシュリーク（Tasyrik）",
    "ko": "줄히자 11–13일 — 타쉬리크(Tasyrik)",
    "hi": "11–13 ज़ुल-हिज्जा — तश्रीक (Tasyrik)"
  },
  "daywada": {
    "id": "Kepulangan",
    "en": "Departure",
    "ar": "العودة والوداع",
    "fr": "Retour",
    "de": "Abreise",
    "es": "Regreso",
    "ru": "Отъезд",
    "zh": "返程",
    "ja": "帰国",
    "ko": "귀환",
    "hi": "वापसी"
  },
  "locBtn": {
    "id": "Lokasi Saya",
    "en": "My Location",
    "ar": "موقعي",
    "fr": "Ma position",
    "de": "Mein Standort",
    "es": "Mi ubicación",
    "ru": "Моё местоположение",
    "zh": "我的位置",
    "ja": "現在地",
    "ko": "내 위치",
    "hi": "मेरा स्थान"
  },
  "locBtnOff": {
    "id": "Matikan Lokasi",
    "en": "Turn Off Location",
    "ar": "إيقاف الموقع",
    "fr": "Désactiver la position",
    "de": "Standort deaktivieren",
    "es": "Desactivar ubicación",
    "ru": "Отключить геолокацию",
    "zh": "关闭位置",
    "ja": "位置情報をオフにする",
    "ko": "위치 끄기",
    "hi": "स्थान बंद करें"
  },
  "locSearching": {
    "id": "Mencari posisi Anda…",
    "en": "Searching for your position…",
    "ar": "جارٍ البحث عن موقعك…",
    "fr": "Recherche de votre position…",
    "de": "Suche nach Ihrem Standort…",
    "es": "Buscando su posición…",
    "ru": "Поиск вашего местоположения…",
    "zh": "正在搜索您的位置…",
    "ja": "現在地を検索中…",
    "ko": "위치를 검색 중…",
    "hi": "आपकी स्थिति खोजी जा रही है…"
  },
  "locNear": {
    "id": "Anda berada di sekitar {station}",
    "en": "You are near {station}",
    "ar": "أنتَ بالقرب من {station}",
    "fr": "Vous êtes près de {station}",
    "de": "Sie befinden sich in der Nähe von {station}",
    "es": "Usted está cerca de {station}",
    "ru": "Вы находитесь вблизи {station}",
    "zh": "您在 {station} 附近",
    "ja": "あなたは {station} の近くにいます",
    "ko": "현재 {station} 근처에 있습니다",
    "hi": "आप {station} के पास हैं"
  },
  "locFar": {
    "id": "Anda {km} km dari Makkah — belum berada di kawasan manasik.",
    "en": "You are {km} km from Makkah — not yet within the manasik area.",
    "ar": "أنتَ على بُعد {km} كم من مكة المكرمة — ولم تصل بعد إلى نطاق المناسك.",
    "fr": "Vous êtes à {km} km de La Mecque — vous n'êtes pas encore dans la zone des manasik.",
    "de": "Sie sind {km} km von Makkah entfernt — noch nicht im Manasik-Bereich.",
    "es": "Usted está a {km} km de La Meca — aún no se encuentra en la zona de manasik.",
    "ru": "Вы находитесь в {km} км от Мекки — вы ещё не в зоне манасик.",
    "zh": "您距离麦加 {km} 公里——尚未进入礼仪区域（manasik）。",
    "ja": "あなたはマッカから {km} km の距離にいます — まだマナーシク区域内にいません。",
    "ko": "현재 메카에서 {km} km 떨어져 있습니다 — 아직 마나식 구역 안에 있지 않습니다.",
    "hi": "आप मक्का से {km} किमी दूर हैं — अभी मनासिक क्षेत्र में नहीं हैं।"
  },
  "locViewStep": {
    "id": "Lihat langkah",
    "en": "View step",
    "ar": "عرض الخطوة",
    "fr": "Voir l'étape",
    "de": "Schritt anzeigen",
    "es": "Ver paso",
    "ru": "Просмотреть шаг",
    "zh": "查看步骤",
    "ja": "ステップを見る",
    "ko": "단계 보기",
    "hi": "चरण देखें"
  },
  "locDenied": {
    "id": "Akses lokasi ditolak. Aktifkan izin lokasi di pengaturan browser/ponsel Anda, lalu ketuk Lokasi Saya lagi.",
    "en": "Location access denied. Enable location permission in your browser/phone settings, then tap My Location again.",
    "ar": "تم رفض الوصول إلى الموقع. فعِّل إذن الموقع في إعدادات المتصفح/الهاتف، ثم اضغط على موقعي مرة أخرى.",
    "fr": "Accès à la localisation refusé. Activez la permission de localisation dans les paramètres de votre navigateur/téléphone, puis appuyez à nouveau sur Ma position.",
    "de": "Standortzugriff verweigert. Aktivieren Sie die Standortberechtigung in Ihren Browser-/Telefoneinstellungen und tippen Sie dann erneut auf Mein Standort.",
    "es": "Acceso a la ubicación denegado. Active el permiso de ubicación en la configuración de su navegador/teléfono y luego toque Mi ubicación nuevamente.",
    "ru": "Доступ к местоположению запрещён. Включите разрешение на определение местоположения в настройках браузера/телефона, затем снова нажмите «Моё местоположение».",
    "zh": "位置访问被拒绝。请在浏览器/手机设置中启用位置权限，然后再次点击\"我的位置\"。",
    "ja": "位置情報へのアクセスが拒否されました。ブラウザ/スマートフォンの設定で位置情報の許可を有効にしてから、「現在地」をもう一度タップしてください。",
    "ko": "위치 접근이 거부되었습니다. 브라우저/휴대폰 설정에서 위치 권한을 활성화한 후 내 위치를 다시 누르세요.",
    "hi": "स्थान पहुँच अस्वीकृत। अपने ब्राउज़र/फ़ोन की सेटिंग में स्थान की अनुमति सक्षम करें, फिर मेरा स्थान पर फिर से टैप करें।"
  },
  "locUnavailable": {
    "id": "GPS tidak tersedia di perangkat ini.",
    "en": "GPS is not available on this device.",
    "ar": "نظام تحديد المواقع (GPS) غير متاح على هذا الجهاز.",
    "fr": "Le GPS n'est pas disponible sur cet appareil.",
    "de": "GPS ist auf diesem Gerät nicht verfügbar.",
    "es": "El GPS no está disponible en este dispositivo.",
    "ru": "GPS недоступен на этом устройстве.",
    "zh": "此设备不支持GPS。",
    "ja": "このデバイスではGPSは利用できません。",
    "ko": "이 기기에서는 GPS를 사용할 수 없습니다.",
    "hi": "इस डिवाइस पर GPS उपलब्ध नहीं है।"
  },
  "locPractice": {
    "id": "Mode Latihan",
    "en": "Practice Mode",
    "ar": "وضع التدريب",
    "fr": "Mode Entraînement",
    "de": "Übungsmodus",
    "es": "Modo Práctica",
    "ru": "Режим практики",
    "zh": "练习模式",
    "ja": "練習モード",
    "ko": "연습 모드",
    "hi": "अभ्यास मोड"
  },
  "locPracticeHint": {
    "id": "Pilih stasiun untuk mensimulasikan posisi Anda dan berlatih membaca peta sebelum berangkat.",
    "en": "Select a station to simulate your position and practice reading the map before you depart.",
    "ar": "اختر محطة لمحاكاة موقعك وتدرَّب على قراءة الخريطة قبل المغادرة.",
    "fr": "Sélectionnez une station pour simuler votre position et vous entraîner à lire la carte avant de partir.",
    "de": "Wählen Sie eine Station aus, um Ihre Position zu simulieren und das Kartenlesen vor der Abreise zu üben.",
    "es": "Seleccione una estación para simular su posición y practicar la lectura del mapa antes de partir.",
    "ru": "Выберите станцию, чтобы смоделировать своё местоположение и потренироваться читать карту перед отправлением.",
    "zh": "选择一个站点来模拟您的位置，并在出发前练习阅读地图。",
    "ja": "出発前に、駅を選択して位置をシミュレートし、地図の読み方を練習してください。",
    "ko": "출발 전에 스테이션을 선택하여 위치를 시뮬레이션하고 지도 읽기를 연습하세요.",
    "hi": "प्रस्थान से पहले अपनी स्थिति अनुकरण करने और मानचित्र पढ़ने का अभ्यास करने के लिए एक स्टेशन चुनें।"
  },
  "locPracticeOn": {
    "id": "Latihan: posisi disimulasikan",
    "en": "Practice: position simulated",
    "ar": "التدريب: الموقع محاكى",
    "fr": "Entraînement : position simulée",
    "de": "Übung: Position simuliert",
    "es": "Práctica: posición simulada",
    "ru": "Практика: позиция смоделирована",
    "zh": "练习：位置已模拟",
    "ja": "練習中：位置をシミュレート中",
    "ko": "연습: 위치 시뮬레이션 중",
    "hi": "अभ्यास: स्थिति अनुकरणीय है"
  },
  "locPracticeOff": {
    "id": "Keluar Mode Latihan",
    "en": "Exit Practice Mode",
    "ar": "الخروج من وضع التدريب",
    "fr": "Quitter le mode Entraînement",
    "de": "Übungsmodus beenden",
    "es": "Salir del Modo Práctica",
    "ru": "Выйти из режима практики",
    "zh": "退出练习模式",
    "ja": "練習モードを終了する",
    "ko": "연습 모드 종료",
    "hi": "अभ्यास मोड से बाहर निकलें"
  },
  "locYou": {
    "id": "Posisi Anda",
    "en": "Your Position",
    "ar": "موضعك",
    "fr": "Votre Position",
    "de": "Ihre Position",
    "es": "Su Posición",
    "ru": "Ваше Местоположение",
    "zh": "您的位置",
    "ja": "あなたの位置",
    "ko": "현재 위치",
    "hi": "आपकी स्थिति"
  },
  "arrived": {
    "id": "Anda telah tiba di {station}",
    "en": "You have arrived at {station}",
    "ar": "لقد وصلت إلى {station}",
    "fr": "Vous êtes arrivé à {station}",
    "de": "Sie sind an {station} angekommen",
    "es": "Ha llegado a {station}",
    "ru": "Вы прибыли в {station}",
    "zh": "您已抵达{station}",
    "ja": "{station}に到着しました",
    "ko": "{station}에 도착하셨습니다",
    "hi": "आप {station} पर पहुँच गए हैं"
  },
  "voiceToggle": {
    "id": "Pengumuman suara saat tiba",
    "en": "Voice announcement upon arrival",
    "ar": "إعلان صوتي عند الوصول",
    "fr": "Annonce vocale à l'arrivée",
    "de": "Sprachansage bei Ankunft",
    "es": "Anuncio de voz al llegar",
    "ru": "Голосовое объявление по прибытии",
    "zh": "到达时语音播报",
    "ja": "到着時の音声アナウンス",
    "ko": "도착 시 음성 안내",
    "hi": "पहुँचने पर आवाज़ की सूचना"
  },
  "dir.N": {
    "id": "Utara",
    "en": "North",
    "ar": "شمال",
    "fr": "Nord",
    "de": "Norden",
    "es": "Norte",
    "ru": "Север",
    "zh": "北",
    "ja": "北",
    "ko": "북",
    "hi": "उत्तर"
  },
  "dir.NE": {
    "id": "Timur Laut",
    "en": "Northeast",
    "ar": "شمال شرق",
    "fr": "Nord-Est",
    "de": "Nordosten",
    "es": "Noreste",
    "ru": "Северо-Восток",
    "zh": "东北",
    "ja": "北東",
    "ko": "북동",
    "hi": "उत्तर-पूर्व"
  },
  "dir.E": {
    "id": "Timur",
    "en": "East",
    "ar": "شرق",
    "fr": "Est",
    "de": "Osten",
    "es": "Este",
    "ru": "Восток",
    "zh": "东",
    "ja": "東",
    "ko": "동",
    "hi": "पूर्व"
  },
  "dir.SE": {
    "id": "Tenggara",
    "en": "Southeast",
    "ar": "جنوب شرق",
    "fr": "Sud-Est",
    "de": "Südosten",
    "es": "Sureste",
    "ru": "Юго-Восток",
    "zh": "东南",
    "ja": "南東",
    "ko": "남동",
    "hi": "दक्षिण-पूर्व"
  },
  "dir.S": {
    "id": "Selatan",
    "en": "South",
    "ar": "جنوب",
    "fr": "Sud",
    "de": "Süden",
    "es": "Sur",
    "ru": "Юг",
    "zh": "南",
    "ja": "南",
    "ko": "남",
    "hi": "दक्षिण"
  },
  "dir.SW": {
    "id": "Barat Daya",
    "en": "Southwest",
    "ar": "جنوب غرب",
    "fr": "Sud-Ouest",
    "de": "Südwesten",
    "es": "Suroeste",
    "ru": "Юго-Запад",
    "zh": "西南",
    "ja": "南西",
    "ko": "남서",
    "hi": "दक्षिण-पश्चिम"
  },
  "dir.W": {
    "id": "Barat",
    "en": "West",
    "ar": "غرب",
    "fr": "Ouest",
    "de": "Westen",
    "es": "Oeste",
    "ru": "Запад",
    "zh": "西",
    "ja": "西",
    "ko": "서",
    "hi": "पश्चिम"
  },
  "dir.NW": {
    "id": "Barat Laut",
    "en": "Northwest",
    "ar": "شمال غرب",
    "fr": "Nord-Ouest",
    "de": "Nordwesten",
    "es": "Noroeste",
    "ru": "Северо-Запад",
    "zh": "西北",
    "ja": "北西",
    "ko": "북서",
    "hi": "उत्तर-पश्चिम"
  },
  "disclaimer": {
    "id": "Materi mengikuti pendapat mayoritas ulama; tetaplah mengikuti bimbingan pembimbing/ustadz rombongan Anda.",
    "en": "This content follows the opinion of the majority of scholars; always follow the guidance of your group's guide or ustadh.",
    "ar": "المحتوى يتبع رأي جمهور العلماء؛ يُرجى الالتزام دائمًا بتوجيهات المرشد أو الأستاذ المرافق لمجموعتكم.",
    "fr": "Ce contenu suit l'avis de la majorité des savants ; suivez toujours les orientations du guide ou de l'ustadh de votre groupe.",
    "de": "Diese Inhalte folgen der Meinung der Mehrheit der Gelehrten; folgen Sie stets der Anleitung des Reiseleiters oder Ustadh Ihrer Gruppe.",
    "es": "Este contenido sigue la opinión de la mayoría de los eruditos; siga siempre la orientación del guía o ustadh de su grupo.",
    "ru": "Материал основан на мнении большинства учёных; всегда следуйте наставлениям руководителя или устаза вашей группы.",
    "zh": "本内容依据多数学者的意见；请始终遵循您所在团队的向导或乌斯塔兹的指导。",
    "ja": "このコンテンツは多数派の学者の意見に基づいています。常にグループのガイドまたはウスタズの指導に従ってください。",
    "ko": "이 내용은 다수 학자들의 의견을 따릅니다; 항상 귀하의 그룹 가이드 또는 우스타즈의 안내를 따르십시오.",
    "hi": "यह सामग्री बहुसंख्यक उलमा की राय पर आधारित है; हमेशा अपने समूह के गाइड या उस्ताज़ के मार्गदर्शन का पालन करें।"
  }
};
